import React, { useEffect, useState } from 'react';
import Navbar from './Navbar'
import { Link } from 'react-router-dom'
import Footer from './Footer'
import Burgernav from './Burgernav'
import PopupRegister from './PopupRegister';
import Whatsapp from './Whatsapp';


export default function Home() {
  const [showModal, setShowModal] = useState(false);
    useEffect(() => {
    const alreadyVisited = localStorage.getItem('alreadyVisited');

    if (!alreadyVisited) {
      const timer = setTimeout(() => {
        setShowModal(true);
        localStorage.setItem('alreadyVisited', 'true');
      }, 5000); // Show modal after 5 seconds

      return () => clearTimeout(timer); // Clean up timer
    }
  }, []);
  return (
    <>
      <>
          {/* <div className="min-h-screen p-6">

      {showModal && <PopupRegister onClose={() => setShowModal(false)} />}
    </div> */}

        <div className="main-wrapper">

          <Navbar />
          <Burgernav />
          {/*End header wrapper*/}
          {/*Begin content wrapper*/}
          <div className="content-wrapper" >
   
            <div
              id="carousel-example-generic"
              className="carousel slide "
              data-ride="carousel"
              data-aos="zoom-in"
            >
              {/* Indicators */}
              <ol className="carousel-indicators">
                <li
                  data-target="#carousel-example-generic"
                  data-slide-to={0}
                  className="active"
                />
                <li data-target="#carousel-example-generic" data-slide-to={1} />
                <li data-target="#carousel-example-generic" data-slide-to={2} />
              </ol>
              {/* Wrapper for slides */}
              <div className="carousel-inner" role="listbox">
                <div className="item active">
                  <img src="./images/litt1.avif" alt="..." />
                  <div className="carousel-caption">LITAANA</div>
                </div>
                <div className="item ">
                  <img src="./images/lit3.avif" alt="..." />
                  <div className="carousel-caption">LITAANA</div>
                </div>

                <div className="item">
                  <img src="./images/litt1.avif" alt="..." />
                  <div className="carousel-caption">LITAANA</div>
                </div>
              </div>

              {/* Controls */}
              <a
                className="left carousel-control"
                href="#carousel-example-generic"
                role="button"
                data-slide="prev"
              >
                <span className="glyphicon glyphicon-chevron-left" aria-hidden="true" />
                <span className="sr-only">Previous</span>
              </a>
              <a
                className="right carousel-control"
                href="#carousel-example-generic"
                role="button"
                data-slide="next"
              >
                <span className="glyphicon glyphicon-chevron-right" aria-hidden="true" />
                <span className="sr-only">Next</span>
              </a>
            </div>


            {/*end slider*/}
            {/*begin upcoming event*/}
            <div className="upcoming-event">
              <div className="container">
                <div className="row upcoming-event__row">
                  <div className="area-img col-md-5 col-sm-12 col-xs-12">
                    <img
                      className="img-responsive animated zoomIn"
                      src="images/upcoming-event.jpg"
                      alt="Inaugural Retreat and North Star Award"
                    />
                  </div>
                  <div className="area-content col-md-7 col-sm-12 col-xs-12">
                    <div className="area-top">
                      <div className="row">
                        <div className="col-sm-10 col-xs-9">
                          <h5 className="heading-light no-margin animated fadeInRight">
                            UPCOMING EVENT
                          </h5>
                          <h2 className="heading-bold animated fadeInLeft">
                            INAUGURAL RETREAT AND NORTH STAR AWARD
                          </h2>
                          <span>
                            <span className="icon map-icon" />
                            <span className="text-place text-light animated fadeInRight">
                              Houston, TX
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-2 col-xs-3">
                          <div className="area-calendar calendar animated slideInRight">
                            <span className="day text-bold">12</span>
                            <span className="month text-light">SEP</span>
                            <span className="year text-light bg-year">2026</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="area-bottom">
                      <div id="time" className="pull-left animated slideInLeft" />
                      <Link
                        to="/event"
                        className="bnt bnt-theme join-now pull-right animated fadeIn"
                      >
                        More Details
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*end upcoming event*/}
            {/*begin alumni interview*/}
          <div className="alumni-interview" data-aos="fade-up">
            <div className="alumni-interview__image">
              <img src="images/LIT Nagpur sRGB.webp" alt="LIT University campus, Nagpur" />
            </div>
            <div className="alumni-interview__content" data-aos="fade-left">
              <div className="interview-wrapper">
                <div className="interview-title" data-aos="fade-down">
                  <h4 className="heading-light text-capitalize">About us</h4>
                  <h1 className="heading-light text-capitalize">Litaana</h1>
                </div>
                <div className="interview-desc text-left" data-aos="fade-up">
                  <p className="text-light">
                    LIT Alumni Association North America [LITAANA] is the North American Chapter of the LIT Alumni Association [LITAA]. LIT University [Formerly Laxminarayan Institute of Technology] is a public state university of the Government of Maharashtra situated at Nagpur, Maharashtra, India. It was established in 1942 and is one of the oldest and the most premier engineering colleges for Chemical Engineering and Technology in India.
                  </p>
                </div>
                <div className="interview-see-story" data-aos="zoom-in">
                  <Link to="/about" className="see-story bnt text-uppercase">
                    More
                  </Link>
                </div>
              </div>
            </div>
          </div>

            {/*end alumni interview*/}
        {/* Hidden per client request — restore when content is ready (Our Responsibility) */}
        {false && (
        <section
  id="responsibility-area"
  style={{ backgroundColor: "#ffffff", marginTop: "60px", fontSize: "20px" }}
  className="section-padding"
  data-aos="fade-up"
>
  <div className="container">
    {/*== Section Title Start ==*/}
    <div className="row">
      <div className="col-lg-12 text-center" data-aos="zoom-in">
        <div className="section-title">
          <h2>Our Responsibility</h2>
        </div>
      </div>
    </div>
    {/*== Section Title End ==*/}

    {/*== Responsibility Content Wrapper ==*/}
    <div className="row text-center text-sm-left">
      {/*== Single Responsibility Start ==*/}
      <div className="col-lg-3 col-sm-6" data-aos="fade-up" data-aos-delay="100">
        <div className="single-responsibility">
          <img src="/images/01.png" alt="Responsibility" />
          <h4>Scholarship</h4>
          <p>
            De create building thinking about your requirment and latest treand
            on our marketplace area
          </p>
        </div>
      </div>
      {/*== Single Responsibility End ==*/}

      {/*== Single Responsibility Start ==*/}
      <div className="col-lg-3 col-sm-6" data-aos="fade-up" data-aos-delay="200">
        <div className="single-responsibility">
          <img src="images/02.png" alt="Responsibility" />
          <h4>Help Current Students</h4>
          <p>
            De create building thinking about your requirment and latest treand
            on our marketplace area
          </p>
        </div>
      </div>
      {/*== Single Responsibility End ==*/}

      {/*== Single Responsibility Start ==*/}
      <div className="col-lg-3 col-sm-6" data-aos="fade-up" data-aos-delay="300">
        <div className="single-responsibility">
          <img src="images/03.png" alt="Responsibility" />
          <h4>Help Our University</h4>
          <p>
            De create building thinking about your requirment and latest treand
            on our marketplace area
          </p>
        </div>
      </div>
      {/*== Single Responsibility End ==*/}

      {/*== Single Responsibility Start ==*/}
      <div className="col-lg-3 col-sm-6" data-aos="fade-up" data-aos-delay="400">
        <div className="single-responsibility">
          <img src="./images/04.png" alt="Responsibility" />
          <h4>Build Our Community</h4>
          <p>
            De create building thinking about your requirment and latest treand
            on our marketplace area
          </p>
        </div>
      </div>
      {/*== Single Responsibility End ==*/}
    </div>
    {/*== Responsibility Content Wrapper ==*/}
  </div>
</section>
        )}


    
            {/*end alumni dashboard*/}
            {/* Hidden per client request — restore when content is ready (Latest News, Career Opportunity, Event Calendar) */}
            {false && (
         <div className="block-links" style={{ marginTop: "60px" }}>
  <div className="container">
    <div className="row">
      {/* Latest News */}
      <div className="block-news col-md-4 col-sm-12 col-xs-12" data-aos="fade-up">
        <div className="column-news">
          <div className="title-links">
            <h3 className="heading-regular">Latest News</h3>
          </div>
          <div className="post-wrapper">
            {/* Repeat AOS on each item */}
            <div className="post-item clearfix" data-aos="zoom-in">
              <div className="image-frame post-photo-wrapper">
                <a href="#"><img src="images/new-img1.jpg" alt="" /></a>
              </div>
              <div className="post-desc-wrapper">
                <div className="post-desc">
                  <div className="post-title">
                    <h6 className="heading-regular"><a href="#">New Lit "Start-Up" in Distrupt 2025</a></h6>
                  </div>
                  <div className="post-excerpt">
                    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Modi, ipsam!</p>
                  </div>
                </div>
              </div>
            </div>
                        <div className="post-item clearfix" data-aos="zoom-in">
              <div className="image-frame post-photo-wrapper">
                <a href="#"><img src="images/new-img1.jpg" alt="" /></a>
              </div>
              <div className="post-desc-wrapper">
                <div className="post-desc">
                  <div className="post-title">
                    <h6 className="heading-regular"><a href="#">New Lit "Start-Up" in Distrupt 2025</a></h6>
                  </div>
                  <div className="post-excerpt">
                    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Modi, ipsam!</p>
                  </div>
                </div>
              </div>
            </div>
                        <div className="post-item clearfix" data-aos="zoom-in">
              <div className="image-frame post-photo-wrapper">
                <a href="#"><img src="images/new-img1.jpg" alt="" /></a>
              </div>
              <div className="post-desc-wrapper">
                <div className="post-desc">
                  <div className="post-title">
                    <h6 className="heading-regular"><a href="#">New Lit "Start-Up" in Distrupt 2025</a></h6>
                  </div>
                  <div className="post-excerpt">
                    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Modi, ipsam!</p>
                  </div>
                </div>
              </div>
            </div>
                        <div className="post-item clearfix" data-aos="zoom-in">
              <div className="image-frame post-photo-wrapper">
                <a href="#"><img src="images/new-img1.jpg" alt="" /></a>
              </div>
              <div className="post-desc-wrapper">
                <div className="post-desc">
                  <div className="post-title">
                    <h6 className="heading-regular"><a href="#">New Lit "Start-Up" in Distrupt 2025</a></h6>
                  </div>
                  <div className="post-excerpt">
                    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Modi, ipsam!</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Add AOS to other .post-item elements */}
            {/* ...repeat for other items... */}
          </div>
          <div className="view-all">
            <Link to="/">View All News</Link>
          </div>
        </div>
      </div>

      {/* Career Opportunity */}
      <div className="block-career col-md-4 col-sm-12 col-xs-12" data-aos="fade-up" data-aos-delay="100">
        <div className="column-career">
          <div className="title-links">
            <h3 className="heading-regular">Career Opportunity</h3>
          </div>
          <div className="career-content">
            <div className="company-item clearfix" data-aos="fade-right">
              <div className="company-logo"><img src="images/company-logo1.png" alt="" /></div>
              <div className="company-desc-wrapper">
                <div className="company-desc">
                  <div className="company-title">
                    <h6 className="heading-regular"><a href="#">Creative Director at StartTrek Inc</a></h6>
                  </div>
                  <div className="company-excerpt"><p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam, fugiat?</p></div>
                </div>
              </div>
            </div>
             <div className="company-item clearfix" data-aos="fade-right">
              <div className="company-logo"><img src="images/company-logo1.png" alt="" /></div>
              <div className="company-desc-wrapper">
                <div className="company-desc">
                  <div className="company-title">
                    <h6 className="heading-regular"><a href="#">Creative Director at StartTrek Inc</a></h6>
                  </div>
                  <div className="company-excerpt"><p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam, fugiat?</p></div>
                </div>
              </div>
            </div>
             <div className="company-item clearfix" data-aos="fade-right">
              <div className="company-logo"><img src="images/company-logo1.png" alt="" /></div>
              <div className="company-desc-wrapper">
                <div className="company-desc">
                  <div className="company-title">
                    <h6 className="heading-regular"><a href="#">Creative Director at StartTrek Inc</a></h6>
                  </div>
                  <div className="company-excerpt"><p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam, fugiat?</p></div>
                </div>
              </div>
            </div>
             <div className="company-item clearfix" data-aos="fade-right">
              <div className="company-logo"><img src="images/company-logo1.png" alt="" /></div>
              <div className="company-desc-wrapper">
                <div className="company-desc">
                  <div className="company-title">
                    <h6 className="heading-regular"><a href="#">Creative Director at StartTrek Inc</a></h6>
                  </div>
                  <div className="company-excerpt"><p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam, fugiat?</p></div>
                </div>
              </div>
            </div>
            {/* ...repeat with AOS... */}
          </div>
          <div className="view-all">
            <Link to="/career">View All Career Opportunity</Link>
          </div>
        </div>
      </div>

      {/* Event Calendar */}
      <div className="block-event-calendar col-md-4 col-sm-12 col-xs-12" data-aos="fade-up" data-aos-delay="200">
        <div className="column-calendar">
          <div className="title-links">
            <h3 className="heading-regular">Event Calendar</h3>
          </div>
          <div className="content-calendar bg-calendar no-padding">
            <div className="top-section">
              <h6 className="heading-light">Litaana 2025</h6>
              <span className="icon calendar-icon pull-right" />
            </div>
            <div className="list-view">
              <div className="view-item" data-aos="fade-left">
                <div className="date-item"><span className="dates text-light">MON 22 MAR</span></div>
                <div className="date-desc-wrapper">
                  <div className="date-desc">
                    <div className="date-title">
                      <h6 className="heading-regular">Club Sponsorship 2025-2026</h6>
                    </div>
                    <div className="date-excerpt"><p>Organizer: Litaana</p></div>
                    <div className="place"><span className="icon map-icon" /><span className="text-place">USA</span></div>
                  </div>
                </div>
              </div>
                   <div className="view-item" data-aos="fade-left">
                <div className="date-item"><span className="dates text-light">MON 22 MAR</span></div>
                <div className="date-desc-wrapper">
                  <div className="date-desc">
                    <div className="date-title">
                      <h6 className="heading-regular">Club Sponsorship 2025-2026</h6>
                    </div>
                    <div className="date-excerpt"><p>Organizer: Litaana</p></div>
                    <div className="place"><span className="icon map-icon" /><span className="text-place">USA</span></div>
                  </div>
                </div>
              </div>
                   <div className="view-item" data-aos="fade-left">
                <div className="date-item"><span className="dates text-light">MON 22 MAR</span></div>
                <div className="date-desc-wrapper">
                  <div className="date-desc">
                    <div className="date-title">
                      <h6 className="heading-regular">Club Sponsorship 2025-2026</h6>
                    </div>
                    <div className="date-excerpt"><p>Organizer: Litaana</p></div>
                    <div className="place"><span className="icon map-icon" /><span className="text-place">USA</span></div>
                  </div>
                </div>
              </div>
                   <div className="view-item" data-aos="fade-left">
                <div className="date-item"><span className="dates text-light">MON 22 MAR</span></div>
                <div className="date-desc-wrapper">
                  <div className="date-desc">
                    <div className="date-title">
                      <h6 className="heading-regular">Club Sponsorship 2025-2026</h6>
                    </div>
                    <div className="date-excerpt"><p>Organizer: Litaana</p></div>
                    <div className="place"><span className="icon map-icon" /><span className="text-place">USA</span></div>
                  </div>
                </div>
              </div>
              {/* ...repeat for other .view-item blocks with different animations... */}
            </div>
          </div>
          <div className="view-all">
            <Link to="/event">View All Events</Link>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
            )}

            {/*end block links*/}

            {/*begin twitter stream*/}
            {/* Hidden per client request — restore when content is ready (quote block) */}
            {false && (
         <div className="twitter-stream" data-aos="fade-up" data-aos-duration="1000">
  <div className="container">
    <div className="twitter-wrapper text-center" data-aos="zoom-in" data-aos-delay="200">
      <div className="twitter-icon color-theme" data-aos="fade-down" data-aos-delay="400">
        <i className="fa fa-twitter" aria-hidden="true" />
      </div>
      <div className="twitter-content">
        <div className="twitter-desc" data-aos="fade-up" data-aos-delay="600">
          <p className="text-light text-center">
            “We feel fortunate to be joining our classmates in welcoming the
            Class of 2025 to the litaana“
          </p>
          <div className="twitter-user" data-aos="fade-in" data-aos-delay="800">
            <span className="avatar-user">
              <img src="images/user9.png" alt="" />
            </span>
            <span className="name">@Litaana</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
            )}

            {/*end twitter stream*/}
            {/*begin instagream*/}
       
            <div className="sliderr">
              <div className="sliderr-row"></div>
            </div>
            {/*end instagream*/}
            {/*begin newsletter*/}
         {/* <div className="newsletter newsletter-parallax" data-aos="fade-up">
      <div className="container">
        <div className="newsletter-wrapper text-center" data-aos="zoom-in" data-aos-delay="200">
          <div className="newsletter-title" data-aos="fade-down" data-aos-delay="300">
            <h2 className="heading-light">Join us on Whatsapp  <i className="fa fa-whatsapp" aria-hidden="true" /></h2>
            <p className="text-white">
              Submit your email id and wait for admin to reach out.
            </p>
          </div>

          <form name="subscribe-form" target="_blank" className="form-inline" data-aos="fade-up" data-aos-delay="400">
            <input
              type="text"
              className="form-control text-center form-text-light"
              name="EMAIL"
              defaultValue=""
              placeholder="E-mail Address"
            />
            <button type="submit" className="button bnt-theme">
              Join Now
            </button>
          </form>
        </div>
      </div>
    </div> */}
    <Whatsapp/>
            {/*end newsletter*/}
          </div>
          {/*End content wrapper*/}
          <Footer />
        </div>

      </>

    </>
  )
}
